<template>
<div >
  <div class="detailsTitle">
      <h4>
        打印
        <el-button type="primary" @click="dayinFN">打印</el-button>
      </h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <div id="printMe"  ref="print">
    <div class="table_title">
        <p>中物唐山曹妃甸物流有限公司</p>
        <p>订单</p>
    </div>
    <p>结算客户：{{goodform.payee}}</p>
    <table style="word-break:break-all;word-wrap:break-all;">
      <tr>
        <td class="td1">要求到达时间</td>
        <td class="td3">{{goodform.arrivalTime|dateFormat1}}</td>
        <td class="td1">回单要求</td>
        <td class="td3">{{goodform.receiptRequest}}</td>
      </tr>
      <tr>
        <td  class="td1">备注</td>
        <td colspan="3">{{goodform.remark}}</td>
      </tr>
    </table>
    <div class="addressBox" style="margin-top:20px">
      <h4>
        <span>收发地址</span>
      </h4>
      <table style="word-break:break-all;word-wrap:break-all;">
        <tr>
          <td  class="td1">发货人</td>
          <td class="td1">{{goodform.deliverPerson}}</td>
          <td class="td1">发货电话</td>
          <td class="td1" style="width:220px">{{goodform.deliverPhone}}</td>
          <td class="td1">发货地址</td>
          <td class="td2">{{goodform.deliverAddress}}</td>
        </tr>
        <tr>
          <td  class="td1">收货人</td>
          <td class="td1">{{goodform.receivingPerson}}</td>
          <td class="td1">收货电话</td>
          <td class="td1" style="width:220px">{{goodform.receivingPhone}}</td>
          <td class="td1">收货地址</td>
          <td class="td2">{{goodform.receivingAddress}}</td>
        </tr>
      </table>
    </div>
    <div class="addressBox" style="margin-top:20px">
      <h4>
        <span>货物信息</span>
      </h4>
      <table style="word-break:break-all;word-wrap:break-all;" v-if="goodform.goodsYn==1">
        <tr>
          <td>序号</td>
          <td>捆包号</td>
          <td>货物类型</td>
          <td>材质</td>
          <td>规格</td>
          <td>重量(吨)</td>
          <td>数量(件)</td>
          <td>体积(方)</td>
          <td>合同号</td>
          <td>合约号</td>
          <td>货位</td>
        </tr>
        <tr v-for="(item, index) in ATableList" :key="index">
          <td >{{ index+1 }}</td>
          <td >{{ item.cargoBarcode }}</td>
          <td >{{ goodform.productTypeName }}</td>
          <td >{{ item.model }}</td>
          <td >{{ item.specification }}</td>
          <td >{{ item.weight?Number(item.weight).toFixed(3):'' }}</td>
          <td >{{ item.number}}</td>
          <td >{{ item.volumn?Number(item.volumn).toFixed(3):'' }}</td>
          <td >{{ item.contractNumber }}</td>
          <td >{{item.agreementNumber}}</td>
          <td >{{item.cargoLocation}}</td>
        </tr>
        <tr>
          <td colspan="5">合计</td>
          <td >{{goodform.allWeight?toFixed(goodform.allWeight,3):''}}</td>
          <td >{{goodform.allNumber?goodform.allNumber:''}}</td>
          <td >{{goodform.allVolumn?toFixed(goodform.allVolumn,3):''}}</td>
          <td ></td>
          <td ></td>
          <td ></td>
        </tr>
      </table>
      <table style="word-break:break-all;word-wrap:break-all;" v-else>
        <tr>
          <td>货物类型</td>
          <td v-if="goodform.weight">重量(吨)</td>
          <td v-if="goodform.orderNumber">数量(件)</td>
          <td v-if="goodform.volumn">体积(方)</td>
        </tr>
        <tr>
          <td >{{goodform.productTypeName}}</td>
          <td  v-if="goodform.weight">{{goodform.weight}}</td>
          <td  v-if="goodform.orderNumber">{{goodform.orderNumber}}</td>
          <td  v-if="goodform.volumn">{{goodform.volumn}}</td>
        </tr>
      </table>
    </div>
    <div class="AMarkFoot">
      <ul>
        <li>打印人:{{goodform.businessUser}}</li>
        <li>打印时间:{{timestamp|dateFormat}}</li>
      </ul>
    </div>
  </div>

</div>
</template>

<script>
import { getOrderInfo } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
export default {
  data () {
    let id = this.$route.query.id
    return {
      toFixed: toFixed,
      id: id,
      goodform: {},
      ATableList: [{}],
      timestamp: null
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.timestamp = new Date().getTime()
    getOrderInfo({ orderBusinessId: this.id }).then(res => {
      this.goodform = res.tOrder
      this.ATableList = res.goodslist
      for (var key in res.tOrderBusiness) {
        if (key != 'id') {
          this.$set(this.goodform, key, res.tOrderBusiness[key])
        }
      }
      this.goodform.allWeight = 0
      this.goodform.allNumber = 0
      this.goodform.allVolumn = 0
      res.goodslist.forEach(item => {
        if (item.weight) {
          this.goodform.allWeight = (this.goodform.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          this.goodform.allNumber = (this.goodform.allNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.volumn) {
          this.goodform.allVolumn = (this.goodform.allVolumn * 1000 + item.volumn * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'businessUser', localStorage.getItem('userName'))
    })
  },
  methods: {
    dayinFN () {
      this.$print(this.$refs.print)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }

}
</script>

<style scoped lang='less'>
#printMe {
  font-size: 16px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
}
table {
  border-collapse: collapse;
}
table,
th,
td {
  border: 1px solid #666;
}
table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
    }
  }
}
</style>
